import type {FC} from 'react';
import {CommonLink} from '../../../../../shared/components/CommonLink';

type Props = {companyId: number; hasReport: boolean};

const BASE_CLASS = 'text-base text-black-1 leading text-center block p-12';

export const CompanyContentTab: FC<Props> = ({companyId, hasReport}) => {
  if (!companyId && !hasReport) return null;
  const widthClass = !companyId || !hasReport ? 'w-1/2' : 'w-1/3';

  return (
    <div className="w-full border-b-[16px] border-collapse border-background-1 flex justify-between">
      {companyId && (
        <CommonLink
          href={`/company/${companyId}`}
          className={`${BASE_CLASS} ${widthClass} bg-black-5`}
        >
          企業情報
        </CommonLink>
      )}
      <p className={`${BASE_CLASS} ${widthClass} font-bold text-primary-1`}>
        募集情報
      </p>
      {hasReport && (
        <CommonLink
          href={`/company/${companyId}/experiences`}
          className={`${BASE_CLASS} ${widthClass} bg-black-5`}
        >
          ES・体験記
        </CommonLink>
      )}
    </div>
  );
};
